module.exports = __webpack_public_path__ + "static/img/rank_125.f3dad6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_125.png
// module id = 3h9m
// module chunks = 1